import { useEffect, useState } from "react";

/**
 * Floating section indicator for case study pages.
 * Highlights the section in view (IntersectionObserver) and jumps on click
 * (via Lenis when available). Desktop-only; unobtrusive dots in the margin.
 */
export const CaseStudyNav = ({ items }) => {
  const [active, setActive] = useState(items[0]?.id);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    items.forEach((it) => {
      const el = document.getElementById(it.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [items]);

  const go = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -110 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className="hidden xl:flex fixed left-6 top-1/2 -translate-y-1/2 z-40 flex-col gap-5"
      aria-label="Case study sections"
      data-testid="case-study-nav"
    >
      {items.map((it) => {
        const isActive = active === it.id;
        return (
          <button
            key={it.id}
            onClick={() => go(it.id)}
            className="group flex items-center gap-3"
            data-testid={`cs-nav-${it.id}`}
          >
            <span
              className={`h-2.5 w-2.5 rounded-full border transition-all duration-300 ${
                isActive
                  ? "bg-[#ff6b6b] border-[#ff6b6b] scale-110"
                  : "bg-transparent border-white/30 group-hover:border-white/60"
              }`}
            />
            <span
              className={`font-mono-accent text-[10px] uppercase tracking-[0.2em] whitespace-nowrap transition-all duration-300 ${
                isActive
                  ? "opacity-100 text-[#fafafa]"
                  : "opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 text-[#c8c8cc]"
              }`}
            >
              {it.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};
